<template>
  <fieldset class="rating-input" id="assign-rating">
    <div class="h3 rating-input__galaxy">
      <!-- 5 Star Rating Begins -->
      <input :disabled="disabled" type="radio" id="star5" v-model="score" value="5" @click="updateValue(5)">
      <label :class="[{ 'disabled': disabled}]" for="star5" title="Great!" @mouseover="handleHoverColor(5)" @mouseleave="disableHoverColor()">
        <img :src="`/static/img/ratings/${starPosition}-star-2x.png`" :alt="`star-rating-${starPosition}`" v-if="starPosition && starPosition >= 5">
        <img :src="`/static/img/ratings/grey-star-2x.png`" :alt="`star-rating-${starPosition}`" v-else>
        <span class="sr-only">5 stars</span>
      </label> <!-- 5 Star Rating Ends -->

      <!-- 4 Star Rating Begins -->
      <input :disabled="disabled" type="radio" id="star4" v-model="score" value="4" @click="updateValue(4)">
      <label :class="[{ 'disabled': disabled}]" for="star4" title="Good" @mouseover="handleHoverColor(4)" @mouseleave="disableHoverColor()">
        <img :src="`/static/img/ratings/${starPosition}-star-2x.png`" :alt="`star-rating-${starPosition}`" v-if="starPosition && starPosition >= 4">
        <img :src="`/static/img/ratings/grey-star-2x.png`" :alt="`star-rating-${starPosition}`" v-else>
        <span class="sr-only">4 stars</span>
      </label> <!-- 4 Star Rating Ends -->

      <!-- 3 Star Rating Begins -->
      <input :disabled="disabled" type="radio" id="star3" v-model="score" value="3" @click="updateValue(3)">
      <label :class="[{ 'disabled': disabled}]" for="star3" title="Average" @mouseover="handleHoverColor(3)" @mouseleave="disableHoverColor()">
        <img :src="`/static/img/ratings/${starPosition}-star-2x.png`" :alt="`star-rating-${starPosition}`" v-if="starPosition && starPosition >= 3">
        <img :src="`/static/img/ratings/grey-star-2x.png`" :alt="`star-rating-${starPosition}`" v-else>
        <span class="sr-only">3 stars</span>
      </label> <!-- 3 Star Rating Ends -->

      <!-- 2 Star Rating Begins -->
      <input :disabled="disabled" type="radio" id="star2" v-model="score" value="2" @click="updateValue(2)">
      <label :class="[{ 'disabled': disabled}]" for="star2" title="Poor" @mouseover="handleHoverColor(2)" @mouseleave="disableHoverColor()">
        <img :src="`/static/img/ratings/${starPosition}-star-2x.png`" :alt="`star-rating-${starPosition}`" v-if="starPosition && starPosition >= 2">
        <img :src="`/static/img/ratings/grey-star-2x.png`" :alt="`star-rating-${starPosition}`" v-else>
        <span class="sr-only">2 stars</span>
      </label> <!-- 2 Star Rating Ends -->

      <!-- 1 Star Rating Begins -->
      <input :disabled="disabled" type="radio" id="star1" v-model="score" value="1" @click="updateValue(1)">
      <label :class="[{ 'disabled': disabled}]" for="star1" title="Terrible" @mouseover="handleHoverColor(1)" @mouseleave="disableHoverColor()">
        <img :src="`/static/img/ratings/${starPosition}-star-2x.png`" :alt="`star-rating-${starPosition}`" v-if="starPosition">
        <img :src="`/static/img/ratings/grey-star-2x.png`" :alt="`star-rating-${starPosition}`" v-else>
        <span class="sr-only">1 star</span>
      </label> <!-- 1 Star Rating Ends -->
    </div>
  </fieldset>
</template>

<script>
  export default {
    props: {
      rating: {
        type: [Number, String]
      },
      disabled: {
        type: Boolean,
        default: false
      },
      spacer: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        score: this.rating,
        starPosition: this.rating
      }
    },
    methods: {
      /**
       * Update value when any star selected
       * @return {void}
       **/
      updateValue: function (e) {
        if (!this.disabled) {
          this.score = Number(e)
          this.$emit('input', this.score)
        }
      },
      /**
       * Enable colors when user hover over mouse
       * @param int colorPosition
       * @return {void}
       **/
      handleHoverColor(colorPosition) {
        if (!this.disabled) {
          this.starPosition = colorPosition
        }
      },
      /**
       * Disable star color when mouse is away of hover
       * @return {void}
       **/
      disableHoverColor () {
        if (!this.disabled) {
          this.starPosition = this.score || 0
        }
      }
    }
  }
</script>
<style scoped>
  *:focus {
    outline: none;
  }
  .rating-input__galaxy {
    padding: 2px 0 0 8px;
  }
  .rating-input__galaxy label img {
    height: 25px;
  }
  .rating-input__galaxy label {
    margin: 0 12px 0 0;
    cursor: pointer;
  }
  .rating-input__galaxy label.disabled {
    cursor: not-allowed;
  }
</style>



// WEBPACK FOOTER //
// src/components/RatingNew.vue